import { Row, Col } from 'antd';
import styled from 'styled-components';

export const RowWithBorder = styled(Row)`
  border: solid #CCCCCC 1px;
  border-radius: 4px;
  padding: 30px;
`;

export const CampoDetalheConsulta = styled(Col)`
  margin-bottom: 5px;
`;
